var BUTTON_SELECTOR = '[data-module=bulk-bump] [data-bulk-bump=button]';
var ERROR_SELECTOR = '[data-module=bulk-bump] [data-bulk-bump=error]';
var DISABLED = 'disabled';
var DISABLED_CLASS = 'btn-disabled';

var PRODUCT_CONTAINER_SELECTOR = '[data-products-list-container]';

var REFRESH_TIME = 1000;

var _$productContainer, _$button, _$errorContainer, _$req, _$refreshTimout;

function init() {
  bindSubmitBumpRequest();
}

function teardown() {
  removeSpinner();
  killPromise();
  clearTimer();
  $(document).off('click.bulkBump');
}

function bindSubmitBumpRequest() {
  $(document).on('click.bulkBump', BUTTON_SELECTOR, function (e) {
    e.preventDefault();

    _$productContainer = $(PRODUCT_CONTAINER_SELECTOR);
    _$button = $(this);
    _$errorContainer = $(ERROR_SELECTOR);

    _$errorContainer.hide();
    handleButton();
    startSpinner();

    _$req = Reverb.APIRequest.post(this.href);
    _$req.success(success);
    _$req.fail(fail);
    _$req.done(function () {
      removeSpinner();
      refreshListings();
    });
  });
}

function handleButton() {
  _$button
    .prop(DISABLED, true)
    .addClass(DISABLED_CLASS)
    .text(I18n.t('js.dashboard.selling.bulkBump.buttonText.bumping'));
}

function success(response) {
  _$productContainer.replaceWith(response);

  _$productContainer = $(PRODUCT_CONTAINER_SELECTOR);
  _$productContainer.trigger('reverb.ajax_load.complete');
}

function fail() {
  _$button
    .prop(DISABLED, false)
    .removeClass(DISABLED_CLASS)
    .text(I18n.t('js.dashboard.selling.bulkBump.buttonText.tryAgain'));

  _$errorContainer.show();
}

function startSpinner() {
  _$productContainer.spin();
}

function removeSpinner() {
  if (_$productContainer) {
    _$productContainer.stopSpinner();
  }
}

function killPromise() {
  if (_$req) {
    _$req.abort();
    _$req = null;
  }
}

function clearTimer() {
  if (_$refreshTimout) {
    clearTimeout(_$refreshTimout);
  }
}

function refreshListings() {
  _$refreshTimout = setTimeout(function () {
    startSpinner();

    _$req = Reverb.APIRequest.get(window.location.href);
    _$req.success(success);
    _$req.fail(fail);
    _$req.done(removeSpinner);

    clearTimer();
  }, REFRESH_TIME);
}

module.exports = {
  init,
  teardown
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/selling/bulk_bump.js